const actions = {
    GET_REPORTE_REQUEST: 'GET_REPORTE_BONIFICACIONES_REQUEST',
    GET_REPORTE_SUCCESS: 'GET_REPORTE_BONIFICACIONES_SUCCESS',
    GET_RESUMEN_REQUEST: 'GET_RESUMEN_BONIFICACIONES_REQUEST',
    GET_RESUMEN_SUCCESS: 'GET_RESUMEN_BONIFICACIONES_SUCCESS',

    getReporte: (query) => ({
        type: actions.GET_REPORTE_REQUEST,
        query,
    }),
    getResumen: (query) => ({
        type: actions.GET_RESUMEN_REQUEST,
        query,
    }),
};

export default actions;
